"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeWrap = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
require("typeface-roboto");
var useMediaQuery_1 = tslib_1.__importDefault(require("@material-ui/core/useMediaQuery"));
var styles_1 = require("@material-ui/core/styles");
var app_theme_1 = tslib_1.__importDefault(require("./app-theme"));
function ThemeWrap(props) {
    var children = props.children;
    var prefersDarkMode = useMediaQuery_1.default("(prefers-color-scheme: dark)");
    var theme = react_1.default.useMemo(function () {
        return styles_1.createMuiTheme({
            palette: {
                type: prefersDarkMode ? "dark" : "light",
                isDark: prefersDarkMode,
            },
            overrides: app_theme_1.default(prefersDarkMode ? "dark" : "light"),
            app: app_theme_1.default(prefersDarkMode ? "dark" : "light"),
        });
    }, [prefersDarkMode]);
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: theme },
        react_1.default.createElement("div", null,
            " ",
            children)));
}
exports.ThemeWrap = ThemeWrap;
//# sourceMappingURL=index.js.map